export default function filterFirstLowerCaseForSpeciality(speciality: string) {
  if (speciality.length > 1) {
    const firstTwoLetters = speciality.slice(0, 2)

    if (firstTwoLetters === firstTwoLetters.toUpperCase()) {
      return speciality
    }
  }

  return speciality.replace(/[А-яЁё\w]+/, match => match.toLowerCase())
}
